import React from 'react';
import {DataGrid, GridToolbar} from '@mui/x-data-grid';

const DataTable = ({
    rows,
    columns,
    loading,
    paginationModel,
    setPaginationModel,
    totalRows,
    disablePagination = false,
    disableServerPagination = false
}) => {
    const paginationSettings = disablePagination ? 
      {
        pagination: false,
        hideFooter: true
      } : 
      {
        paginationMode: disableServerPagination ? "client" : "server",
        paginationModel: paginationModel,
        onPaginationModelChange: setPaginationModel,
        rowCount: totalRows,
        hideFooterSelectedRowCount: true
      };

    return (
        <div style={{ 
          height: disablePagination ? "auto" : "80vh", 
          width: "100%", 
          overflowY: "auto", 
          minHeight: disablePagination ? "auto" : "400px" 
        }}>
            <DataGrid
                rows={rows}
                columns={columns}
                loading={loading}
                autoHeight={disablePagination}
                slots={{
                  toolbar: null  // Remove the toolbar completely
                }}
                disableColumnFilter
                disableColumnSelector
                disableDensitySelector
                {...paginationSettings}
            />
        </div>
    );
};

export default DataTable;